import { Button } from '@travelnest/merlin.button';
import { ILocationSearchResult, LocationSearch } from '@travelnest/merlin.location-search';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { Character } from '../../../constants';
import { Paragraph } from '../../paragraph/Paragraph';

interface IPropertyShellTypeStepProps {
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
	address?: ILocationSearchResult | null;
	onAddressUpdate: (address: ILocationSearchResult | null) => any;
}

export const PropertyShellAddressStep: React.FC<IPropertyShellTypeStepProps> = (props) => {
	const clearAddress = () => props.onAddressUpdate(null);

	return <Modal
		title="Add a new property"
		onRequestClose={props.onRequestClose}
		shouldCloseOnOverlayClick={false}
		actionLHS={
			<Button
				onClick={props.onRequestPrevious}
				bgColor={theme.colours.background.default}
				color={theme.colours.text.black}
				className="travelnest-modal__button-align"
			>
				<span className="travelnest-modal__icon">{Character.Left}</span>
				<span>Previous</span>
			</Button>
		}
		actionRHS={
			<Button
				onClick={() => props.address && props.onRequestNext()}
				bgColor={props.address ? theme.colours.success.primary : theme.colours.neutral.light}
				color={theme.colours.text.white}
				hoverColor={theme.colours.success.primary}
				className="travelnest-modal__button-align"
			>
				<span>Next</span>
				<span className="travelnest-modal__icon">{Character.Right}</span>
			</Button>
		}>
			<div>
				<Paragraph>What is the property's address?</Paragraph>
				{props.address ?
					<>
						<Paragraph>{props.address!.raw}</Paragraph>
						<Button onClick={clearAddress}>Change Address</Button>
					</>
					:
					<LocationSearch
						onSelect={(address) => props.onAddressUpdate(address)}
					/>
				}

			</div>
	</Modal>;
};
